import { FlexContainer } from '@news12/storybook-news'

import { useState, useEffect } from 'react'

import Loading from '../components/Loading'
import internalApiQueryWrapper from '../core/internalApiQueryWrapper'
import buttonStyle from '../styles/components/componentMap/button'
import { markdown, structure } from '../styles/global'
import BaseCSS from '../styles/global/BaseCSS'
import { search } from '../styles/pages/search'
import getStoryHref from '../utils/getStoryHref'
import AdUnit from './Ads/AdUnit'
import { useEnvironmentContext } from './EnvironmentProvider'
import Search from './Header/Search'
import UnresetCSS from './UnresetCSS'

import moment from 'moment'
import Link from 'next/link'

export const Button = ({ handleClick }) => (
  <>
    <button onClick={handleClick} data-testid='load-more-button'>
      Load more
    </button>
    <style jsx>{buttonStyle}</style>
  </>
)

export const Results = ({ queryString }) => {
  const { canonicalUrlRedirects } = useEnvironmentContext()
  const [collection, setCollection] = useState([])
  const [total, setTotal] = useState(0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const loadStories = async (isQueryStringChanged = false) => {
    setLoading(true)

    try {
      const data = await internalApiQueryWrapper('/api/contentful/search', {
        q: queryString,
        skip: isQueryStringChanged ? 0 : collection.length
      })
      setCollection(prevCollection => [...prevCollection, ...data.stories])
      setTotal(data.total)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setError(null)
    setCollection([])
    setTotal(0)
    loadStories(true)
  }, [queryString])

  const loadMore = () => loadStories()

  if (error) return <div>Error loading search results</div>

  if (!collection.length && loading) {
    return <div>Searching content...</div>
  }
  return (
    <>
      <Search queryString={queryString} style={search} />
      <div className='hitcount'>
        {`${total} ${total === 1 ? 'result' : 'results'} for `}
        <span className='search-term'>{queryString}</span>
      </div>
      <div className='container-list' role='list' data-testid='search-results-list'>
        {collection?.map((item, index) => (
          <Link
            key={index}
            href={getStoryHref(item, {
              canonicalUrlRedirects
            })}>
            <span className='item' role='listitem'>
              <div className='container-image'>
                <img src={item.thumbnail} alt={item.title} />
              </div>
              <div className='container-content'>
                <div className='container-date'>
                  <span className='date'>{moment(item.publishedAt).format('MMM D, YYYY h:mm A')}</span>
                  {item.videoFile?.duration && (
                    <div className='play-icon-container' role='presentation'>
                      <div className='play-icon' />
                    </div>
                  )}
                </div>
                <div className='container-title'>
                  <h4>{item.title}</h4>
                </div>
                <div className='container-description'>
                  <p>{item.description}</p>
                </div>
              </div>
            </span>
          </Link>
        ))}
      </div>
      {loading && collection.length && <Loading />}
      {total !== 0 && <Button handleClick={loadMore} />}
      <style jsx>{search}</style>
    </>
  )
}

const List = props => (
  <div className='container horizontal'>
    <div className='section'>
      <FlexContainer justifyContent='center'>
        <AdUnit adUnitTemplate='leaderboard' id='ad-search-leaderboard' type='leaderboard' />
      </FlexContainer>
    </div>
    <div className='section'>
      <div className='container horizontal'>
        <div className='section results'>
          <Results {...props} />
        </div>
        <div className='section sidebar'>
          <FlexContainer justifyContent='center'>
            <AdUnit adUnitTemplate='rectangleVertical' id='ad-search-sidebar' type='sidebar' />
          </FlexContainer>
        </div>
      </div>
    </div>
    <style jsx global>
      {structure}
    </style>
    <UnresetCSS />
    <BaseCSS />
    <style jsx global>
      {markdown}
    </style>
    <style jsx>{search}</style>
  </div>
)

export default List
